import { DimensionsUI } from "./DimensionsUI";
import { StandardProps } from "../componentMap";
import {
  formatProductTypeForDimensions,
  largeElecSellingTypes,
} from "./dimensionsUtils";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getAttributeValues } from "../../utils/product/getAttributeValues";
import { getAttributeValuesFromHierarchy } from "../../utils/product/getAttributeValuesFromHierarchy";

export function Dimensions({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const { variant } = useVariant(product);
  const variantAttributes = variant.attributes;

  // Hide component when RHR layout is active ("rhr") or isolated accordion layout is active ("accordion")
  // Show when flag is empty/default (coexistence layout)
  const flagValue = flags.enablePremiumRhrSideDrawers.value;
  if (flagValue === "rhr") {
    return null;
  }

  // Only render for large electrical products and televisions
  if (
    !product.sellingProductType ||
    !largeElecSellingTypes.includes(product.sellingProductType)
  ) {
    return null;
  }

  const productType = formatProductTypeForDimensions(
    product.sellingProductType,
  );

  const dimensions = getAttributeValuesFromHierarchy(
    "dimensions",
    product.attributes,
    variantAttributes ?? [],
  );

  // aperture only exists in product level attributes
  const aperture = getAttributeValues(
    "combinedaperturedimensions",
    product.attributes,
  );

  return (
    <DimensionsUI
      productType={productType}
      dimensions={dimensions[0]}
      aperture={aperture[0]}
    />
  );
}
